import { Typography } from "@material-ui/core"

const Revisions = (props) => {

  return ( <>
    <Typography>
      Absolutely! We want your song to be perfect, so we offer up to five rounds of revisions. Whether you need a small tweak, a new verse, or you suddenly realize you must include a reference to your dog’s obsession with peanut butter, just let us know. We’ll fine-tune it until it’s exactly what you imagined—or <b>even better</b>!
    </Typography>
  </> )
}

export default Revisions
